export default "__VITE_ASSET__Bp5BK3C7__"